const variablesConfig = {
  variables: {
    LIMITED_EDITION_SMALL_PRICE: 100,
    LIMITED_EDITION_NORMAL_PRICE: 200,
    LIMITED_EDITION_LARGE_PRICE: 300,
  },
};

export default variablesConfig;
